"use client"

import styled from "@emotion/styled"
import { useIsDesktop } from "@eurodrive/ui"
import { getNonUmbracoUrl } from "@eurodrive/utils"
import { imageGalleryInteraction } from "@eurodrive/utils/gtm"
import { IconButton } from "@mui/material"
import Image from "next/image"
import { Navigation } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"

const StyledSwiper = styled(Swiper)`
  height: 348px;
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 515px;
  }
  width: 100%;
  border-radius: 8px;
  overflow: hidden;

  .swiper-button-prev,
  .swiper-button-next {
    display: flex;
    width: 32px;
    height: 32px;
    padding: 10px 0px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background: #fff;

    &:after {
      display: none;
    }
  }
`

const NavigationArrow = styled(IconButton)`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 10px 0px;
  justify-content: center;
  align-items: center;
  border-radius: 4px !important;
  background: #fff;
  width: fit-content;
  &:hover {
    background: white;
  }
`
const NavigationButtons = styled.div`
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  z-index: 10;
`

export default function GridSwiper({
  desktopImages,
  mobileImages,
  vehicleId = "unknown",
}: {
  desktopImages: any
  mobileImages: any
  vehicleId?: string
}) {
  const isDesktop = useIsDesktop()
  const images = isDesktop ? desktopImages : mobileImages

  const handleSlideChange = (swiper: any) => {
    imageGalleryInteraction(vehicleId, String(swiper.activeIndex + 1))
  }

  const handleNavClick = () => {
    // Track navigation button clicks
    // Note: Swiper will trigger onSlideChange after navigation
  }

  if (!images || images.length === 0) {
    return null
  }

  return (
    <StyledSwiper
      modules={[Navigation]}
      slidesPerView={1}
      navigation={{
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next",
      }}
      pagination={{ clickable: true }}
      onSlideChange={handleSlideChange}
      style={{
        width: "100%",
      }}
    >
      {images?.length > 0 &&
        images.map((el: any, i: number) => (
          <SwiperSlide key={i}>
            <Image
              src={getNonUmbracoUrl(el.url)}
              alt={el.altText}
              fill
              style={{ objectFit: "cover" }}
            />
          </SwiperSlide>
        ))}
      <NavigationButtons>
        <NavigationArrow
          className="swiper-button-next"
          onClick={handleNavClick}
        >
          <Image
            src="/icons/chevron-right.svg"
            alt="Next"
            width={12}
            height={12}
          />
        </NavigationArrow>
        <NavigationArrow
          className="swiper-button-prev"
          onClick={handleNavClick}
        >
          <Image
            src="/icons/chevron-left.svg"
            alt="Previous"
            width={12}
            height={12}
          />
        </NavigationArrow>
      </NavigationButtons>
    </StyledSwiper>
  )
}
